import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import TimeLimitContext from '../../context/TimeLimitContext';
import StealCapContext from '../../context/StealCapContext';

import Navbar from '../../components/Navbar/Navbar';
import Title from '../../components/Title/Title';

import Xicon from '../../img/x.png';
import rosterImg from '../../img/home/roster.png';
import build11Img from '../../img/home/build11.png';
/* import penaltyImg from '../../img/home/roster.jpg'; */
import tictactoeImgBot from '../../img/home/tictactoe-bot.jpg';
import tictactoeImgLocal from '../../img/home/tictactoe-local.jpg';
import tictactoeImgOnline from '../../img/home/tictactoe-online.jpg';
import WorldLogo from '../../img/WorldLogo.png';
import AfaLogo from '../../img/AfaLogo.png';
import guessImg from '../../img/home/guess-player.png';
import clasicoBotImg from '../../img/modeSelector/clasicoBot.png';
import roboBotImg from '../../img/modeSelector/roboBot.png';
import four12Img from '../../img/modeSelector/412.jpeg';
import clubRaceImg from '../../img/home/club-race.svg';
import careerImg from '../../img/home/career-cover.png';

import './HomePage.css';

const APP_STORE_URL = 'https://apps.apple.com/us/app/footy-games/id6761481875';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.footygames.tictactoe';

// ── Modo online PC temporalmente deshabilitado ────────────────────────────────
const ONLINE_ENABLED = false;
// ─────────────────────────────────────────────────────────────────────────────

const announcementCopy = {
  es: {
    eyebrow: '📱 DISPONIBLE EN iOS Y ANDROID',
    title: 'Footy Games llega a tu celular',
    description: 'Jugá online contra otras personas, desbloqueá modos exclusivos y mucho más. La app de Footy Games ya está disponible en App Store y Google Play.',
    features: ['Multijugador online', 'Modos exclusivos', 'Campaña y rankings'],
    ctaIos: 'App Store',
    ctaAndroid: 'Google Play',
  },
  en: {
    eyebrow: '📱 AVAILABLE ON iOS & ANDROID',
    title: 'Footy Games is now on mobile',
    description: 'Play online against other people, unlock exclusive game modes and much more. The Footy Games app is now available on App Store and Google Play.',
    features: ['Online multiplayer', 'Exclusive modes', 'Campaign & rankings'],
    ctaIos: 'App Store',
    ctaAndroid: 'Google Play',
  },
};

// Nombre y explicación de cada variante, para el botón "¿Qué es …?" del selector de modo.
// Tener las 3 en un mapa evita el bug de ternarios encadenados que mostraba el texto de un
// modo estando seleccionado otro; al sumar una variante nueva, alcanza con agregarla acá.
const VARIANT_INFO = {
  classic: {
    nombre: 'Clásico',
    texto: (
      <>
        El tatetí de siempre: por turnos, elegís una casilla vacía y ponés un jugador que
        cumpla los <strong>dos requisitos</strong> del cruce (el de su fila y el de su
        columna). Si el jugador no cumple, perdés el turno. Gana el primero que hace
        <strong> 3 en línea</strong>.
      </>
    ),
  },
  four12: {
    nombre: 'Modo 412',
    texto: (
      <>
        Las 9 casillas arrancan <strong>ocultas</strong>: no ves ningún club, país ni logro
        hasta que elegís dónde jugar. Al tocar una casilla vacía se revelan sus dos requisitos
        (fila y columna) — pero quedás <strong>comprometido</strong> con esa casilla: no podés
        elegir otra hasta poner ahí un jugador que cumpla los dos requisitos. Si no encontrás a
        nadie, usá <strong>Skip Turn</strong> para pasar el turno sin perder lo ya revelado.
      </>
    ),
  },
  steal: {
    nombre: 'Robo de casillas',
    texto: (
      <>
        Podés robarle al rival una casilla que ya puso, poniendo un jugador distinto que también
        cumpla los requisitos. No podés repetir un jugador que ya se usó en ESA casilla (sí podés
        usarlo en otra). Por default una casilla se puede jugar hasta <strong>3 veces</strong> en
        total, y después queda <strong>bloqueada</strong> para siempre con quien la tenga en ese
        momento — podés cambiar ese tope desde ⚙️ Configuración en la Home. También podés reforzar
        tu propia casilla con otro jugador: no cambia de dueño, y la <strong>blinda para siempre
        al instante, gratis</strong> (no gasta tu blindaje único). Además, cada jugador tiene un
        🛡️ <strong>blindaje único</strong> por partida, separado del refuerzo: activalo con el
        botón correspondiente y la próxima casilla que juegues correctamente (la que elijas, sea
        tuya, vacía o robada) queda intocable para siempre al instante.
      </>
    ),
  },
};

const HomePage = () => {
  const navigate = useNavigate();
  const { timeLimit, setTimeLimit } = useContext(TimeLimitContext);
  const { stealCap, setStealCap } = useContext(StealCapContext);
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(true);
  const [announcementLanguage, setAnnouncementLanguage] = useState('es');

  // Estados para los modales y para el mensaje de usuario
  const [showBuild11Modal, setShowBuild11Modal] = useState(false);
  const [showOtherModesModalOnline, setShowOtherModesModalOnline] = useState(false);
  const [showOtherModesModalPlayerFinder, setShowOtherModesModalPlayerFinder] = useState(false);
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const [showClubRaceModal, setShowClubRaceModal] = useState(false);
  // Selector de modo de juego (Clásico vs Robo) para Local/Bot, antes de elegir liga.
  const [pendingVariantFor, setPendingVariantFor] = useState(null); // 'local' | 'bot' | null
  const [showVariantInfo, setShowVariantInfo] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState('four12');
  const [showCareerBanner, setShowCareerBanner] = useState(
    () => localStorage.getItem('careerBannerDismissed') !== 'true'
  );

  const dismissCareerBanner = () => {
    localStorage.setItem('careerBannerDismissed', 'true');
    setShowCareerBanner(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setShowAnnouncementModal(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="home-page-container">
      <Navbar />
      <Title />

      {showCareerBanner && (
        <div className="career-banner" onClick={() => navigate('/career')}>
          <span className="career-banner-text">
            🎮 <strong>Nuevo juego:</strong> Carrera de Élite ya está disponible
          </span>
          <button
            type="button"
            className="career-banner-close"
            onClick={(e) => { e.stopPropagation(); dismissCareerBanner(); }}
            aria-label="Cerrar aviso"
          >✕</button>
        </div>
      )}

      {showAnnouncementModal && (
        <div
          className="home-announcement-overlay"
          role="presentation"
          onClick={() => setShowAnnouncementModal(false)}
        >
          <section
            className="home-announcement-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="home-announcement-title"
            aria-describedby="home-announcement-description"
            onClick={(event) => event.stopPropagation()}
          >
            {/* Language switcher — top right */}
            <div className="ann-lang-row">
              <button
                type="button"
                className={`ann-lang-btn ${announcementLanguage === 'es' ? 'ann-lang-btn--active' : ''}`}
                onClick={() => setAnnouncementLanguage('es')}
              >ES</button>
              <button
                type="button"
                className={`ann-lang-btn ${announcementLanguage === 'en' ? 'ann-lang-btn--active' : ''}`}
                onClick={() => setAnnouncementLanguage('en')}
              >EN</button>
              <button
                className="ann-close"
                type="button"
                onClick={() => setShowAnnouncementModal(false)}
                aria-label="Close"
              >✕</button>
            </div>

            {/* Hero block */}
            <div className="ann-hero">
              <div className="ann-logo-wrap">
                <img src="/logo.png" alt="Footy Games" className="ann-logo" />
              </div>
              <div className="ann-hero-text">
                <span className="ann-eyebrow">{announcementCopy[announcementLanguage].eyebrow}</span>
                <h2 className="ann-title" id="home-announcement-title">
                  {announcementCopy[announcementLanguage].title}
                </h2>
              </div>
            </div>

            {/* Description */}
            <p className="ann-desc" id="home-announcement-description">
              {announcementCopy[announcementLanguage].description}
            </p>

            {/* Feature pills */}
            <div className="ann-features">
              {announcementCopy[announcementLanguage].features.map((f) => (
                <span key={f} className="ann-feature-pill">✓ {f}</span>
              ))}
            </div>

            {/* CTA row */}
            <div className="ann-actions">
              <a
                className="ann-cta"
                href={APP_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <svg className="ann-apple-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                {announcementCopy[announcementLanguage].ctaIos}
              </a>
              <a
                className="ann-cta ann-cta--android"
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
              >
                <svg className="ann-android-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"/>
                </svg>
                {announcementCopy[announcementLanguage].ctaAndroid}
              </a>
            </div>
          </section>
        </div>
      )}

      {/* Contenedor de las cards */}
      <div className="cards-container">
        {/* Primera fila: Tic-Tac-Toe (BOT, LOCAL, ONLINE) */}
        <div className="cards-row tic-tac-toe-row">
          <div className="game-card" onClick={() => setPendingVariantFor('bot')}>
            <img src={tictactoeImgBot} alt="Tic Tac Toe Bot" />
            <h2>TIC-TAC-TOE</h2>
            <div className="card-bottom bot">
              <p>(BOT)</p>
            </div>
          </div>

          <div className="game-card" onClick={() => setPendingVariantFor('local')}>
            <img src={tictactoeImgLocal} alt="Tic Tac Toe Local" />
            <h2>TIC-TAC-TOE</h2>
            <div className="card-bottom local">
              <p>(LOCAL)</p>
            </div>
          </div>

          {ONLINE_ENABLED && (
            <div className="game-card" onClick={() => setShowOtherModesModalOnline(true)}>
              <img src={tictactoeImgOnline} alt="Tic Tac Toe Online" />
              <h2>TIC-TAC-TOE</h2>
              <div className="card-bottom online">
                <p>(ONLINE)</p>
              </div>
            </div>
          )}

          <div
            className="game-card game-card--shiny"
            onClick={() => navigate('/career')}
          >
            <div className="new-badge new-badge--shiny">JUEGO NUEVO</div>
            <img src={careerImg} alt="Carrera de Élite" />
            <h2>CARRERA DE ÉLITE</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>
        </div>

        {/* Segunda fila: ROSTER (SOLO) y BUILD11 (SOLO) */}
        <div className="cards-row">
          <div
            className="game-card"
            onClick={() => navigate('/roster', { state: { mode: 'normal' } })}
          >
            <img src={rosterImg} alt="Roster Solo" />
            <h2>ROSTER</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>

          <div className="game-card" onClick={() => setShowBuild11Modal(true)}>
            <img src={build11Img} alt="Build11 Solo" />
            <h2>BUILD11</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>

          <div
            className="game-card"
            onClick={() => navigate('/guess-player')}
          >
            <img src={guessImg} alt="Guess the Player" />
            <h2>GUESS THE PLAYER</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div>

          <div
            className="game-card"
            onClick={() => setShowClubRaceModal(true)}
          >
            <img src={clubRaceImg} alt="Club Race" />
            <h2>CLUB RACE</h2>
            <div className="card-bottom bot">
              <p>(VS BOTS)</p>
            </div>
          </div>

{/*           <div className="game-card" onClick={() => navigate('/penalty', {
            state: {
              combinationWinner: 'user',      // o 'bot' 
              startingAction: 'userShoot'     // o 'botShoot'
            }
          })}>
            < img src={penaltyImg} alt="Penalty" />
            <h2>PENALTY</h2>
            <div className="card-bottom solo">
              <p>(SOLO)</p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Bar con emojis */}
      <div className="top-bar">
        <button className="icon-button" onClick={() => navigate(`/ranking`)}>
          <span role="img" aria-label="Ranking">🏆</span>
        </button>
        <button className="icon-button" onClick={() => setShowConfigureModal(true)}>
          <span role="img" aria-label="Configuración">⚙️</span>
        </button>
        <button className="icon-button" onClick={() => setShowOtherModesModalPlayerFinder(true)}>
          <span role="img" aria-label="Búsqueda">🔍</span>
        </button>
      </div>

      {/*
        ======================================================================
        MODALES
        ======================================================================
      */}

      {
        showBuild11Modal && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowBuild11Modal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/squad`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/squad-arg`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        pendingVariantFor && (
          <div className="other-modes-modal">
            <div className="other-modes-content variant-modal-content">
              <div className="other-modes-header">
                <h3>Elegí cómo jugar</h3>
                <button
                  className="close-modal-button"
                  onClick={() => { setPendingVariantFor(null); setShowVariantInfo(false); }}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>

              <div className="variant-section-label">Modo de juego</div>
              <div className="variant-toggle">
                <button
                  type="button"
                  className={`variant-toggle-btn variant-toggle-btn--classic${selectedVariant === 'classic' ? ' variant-toggle-btn--active' : ''}`}
                  onClick={() => setSelectedVariant('classic')}
                >
                  <span className="variant-art">
                    <img src={clasicoBotImg} alt="" className="variant-art-img" loading="lazy" />
                  </span>
                  <span className="variant-name">Clásico</span>
                  <span className="variant-desc">El tatetí de siempre</span>
                </button>
                {/* Modo 412 va al medio y viene seleccionado por default: es el modo nuevo,
                    así que ocupa el lugar de más peso visual del selector. */}
                <button
                  type="button"
                  className={`variant-toggle-btn variant-toggle-btn--four12${selectedVariant === 'four12' ? ' variant-toggle-btn--active' : ''}`}
                  onClick={() => setSelectedVariant('four12')}
                >
                  <span className="variant-new-badge">NUEVO</span>
                  <span className="variant-art">
                    <img src={four12Img} alt="" className="variant-art-img variant-art-img--cover" loading="lazy" />
                  </span>
                  <span className="variant-name">Modo 412</span>
                  <span className="variant-desc">Casillas ocultas</span>
                </button>
                <button
                  type="button"
                  className={`variant-toggle-btn variant-toggle-btn--steal${selectedVariant === 'steal' ? ' variant-toggle-btn--active' : ''}`}
                  onClick={() => setSelectedVariant('steal')}
                >
                  <span className="variant-art">
                    <img src={roboBotImg} alt="" className="variant-art-img" loading="lazy" />
                  </span>
                  <span className="variant-name">Robo de casillas</span>
                  <span className="variant-desc">Robale al rival</span>
                </button>
              </div>
              {/* El botón y el texto salen del mismo mapa (VARIANT_INFO), indexado por el modo
                  elegido. Antes eran ternarios encadenados con "412 vs todo lo demás", así que
                  con Clásico seleccionado el botón ofrecía "¿Qué es Robo de casillas?" y al
                  abrirlo no mostraba nada (no había bloque para Clásico). */}
              <button
                type="button"
                className="variant-info-button"
                onClick={() => setShowVariantInfo(prev => !prev)}
                aria-label={`Info ${VARIANT_INFO[selectedVariant].nombre}`}
              >
                ℹ️ ¿Qué es "{VARIANT_INFO[selectedVariant].nombre}"?
              </button>
              {showVariantInfo && (
                <p className="variant-info-text">{VARIANT_INFO[selectedVariant].texto}</p>
              )}

              <div className="variant-section-label variant-section-label--league">Elegí la liga</div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => {
                    const path = pendingVariantFor === 'local' ? '/local' : '/solo-bot';
                    navigate(path, { state: { mode: 'normal', variant: selectedVariant } });
                    setPendingVariantFor(null);
                    setShowVariantInfo(false);
                  }}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => {
                    const path = pendingVariantFor === 'local' ? '/local' : '/solo-bot-arg';
                    navigate(path, { state: { mode: 'arg', variant: selectedVariant } });
                    setPendingVariantFor(null);
                    setShowVariantInfo(false);
                  }}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModalOnline && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModalOnline(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/room`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/room`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showConfigureModal && (
          <div className="join-room-modal">
            <div className="join-room-content">
              <div className="join-room-header">
                <h3 className="config-h3">Configure Room (TIC-TAC-TOE)</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowConfigureModal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="join-room-form">
                <label htmlFor="timeLimit">TIME LIMIT PER TURN:</label>
                <select
                  value={timeLimit}
                  onChange={(e) => setTimeLimit(parseInt(e.target.value, 10))}
                >
                  <option value={20}>20 seconds</option>
                  <option value={30}>30 seconds</option>
                  <option value={60}>1 minute</option>
                  <option value={120}>2 minutes</option>
                  <option value={180}>3 minutes</option>
                  <option value={240}>4 minutes</option>
                  <option value={300}>5 minutes</option>
                </select>
                <label htmlFor="stealCap">MAX JUGADAS POR CASILLA (Modo Robo, default 3):</label>
                <select
                  value={stealCap}
                  onChange={(e) => setStealCap(e.target.value === 'unlimited' ? 'unlimited' : parseInt(e.target.value, 10))}
                >
                  <option value="unlimited">Ilimitado</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                  <option value={5}>5</option>
                </select>
              </div>
            </div>
          </div>
        )
      }

      {
        showClubRaceModal && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Club Race:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowClubRaceModal(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate('/club-race')}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate('/club-race-arg')}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        showOtherModesModalPlayerFinder && (
          <div className="other-modes-modal">
            <div className="other-modes-content">
              <div className="other-modes-header">
                <h3>Choose league:</h3>
                <button
                  className="close-modal-button"
                  onClick={() => setShowOtherModesModalPlayerFinder(false)}
                >
                  <img className="x-icon" src={Xicon} alt="Cerrar" />
                </button>
              </div>
              <div className="other-modes-form">
                <button
                  className="football-button"
                  onClick={() => navigate(`/player-finder`, { state: { mode: 'normal' } })}
                >
                  <img className="football-logo" src={WorldLogo} alt="World Logo" />
                  Normal Mode (World)
                </button>
                <button
                  className="football-button"
                  onClick={() => navigate(`/player-finder-arg`, { state: { mode: 'arg' } })}
                >
                  <img className="football-logo" src={AfaLogo} alt="AFA Logo" />
                  Argentinian League
                </button>
              </div>
            </div>
          </div>
        )
      }

    </div >
  );
};

export default HomePage;
